import { io } from 'socket.io-client';

const socket = io.connect(process.env.VUE_APP_SOCKET_URL, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity,
});

socket.on('connect_error', () => {
  console.log('connect error');
  setTimeout(() => {
    socket.connect();
  }, 1000);
});

if (!socket.connected) {
  console.log('connected');
  socket.connect();
}

export default socket;
